import * as ActionTypes from '../action-types'
import { deepMerge } from '../../util'

import { TEMPLATE } from '../../../constants'

/**
 * Constant
 */

const {
    VEHICLE_TRANSIT_STATUS_OBJECT
} = TEMPLATE.STATUS

const vehicles_DefaultState = {
    staticsByID: {},
    fuelProfileByID: {}, 
    vehiclePKGByID: {},
    stateByID: {},
    derivativeStateByID: {},
    geoStateByID: {},
    MDVRStatesByID: {},
    byTransitStatus: {
        [VEHICLE_TRANSIT_STATUS_OBJECT.ALL]: [],
        [VEHICLE_TRANSIT_STATUS_OBJECT.MOVING]: [],
        [VEHICLE_TRANSIT_STATUS_OBJECT.IDLING]: [],
        [VEHICLE_TRANSIT_STATUS_OBJECT.PARKING]: [],
        [VEHICLE_TRANSIT_STATUS_OBJECT.DISCONNECTED]: []
    },
    allIDs: [],
    selectedID: ''
}

export const vehicles = (state = vehicles_DefaultState, action) => {

    let newState = JSON.parse(JSON.stringify(state))

    if(!action) return newState

    switch (action.type) {
        case ActionTypes.CLEAR_SELECTED_VEHICLE: {
            newState.selectedID = ''
            return newState
        }
        case ActionTypes.GET_VEHICLE: {

            const vehicleStatics = action.vehicleStatics
            const vehicleState = action.vehicleState
            const vehicleDerivativeState = action.vehicleDerivativeState
            const vehicleGeoState = action.vehicleGeoState
            const vehicleFuelProfile = action.vehicleFuelProfile
            const vehiclePackageProfile = action.vehiclePackageProfile 

            const vid =  (vehicleStatics && vehicleStatics.vid) || (vehicleState && vehicleState.vid)

            if(vid) {

                if(Object.prototype.hasOwnProperty.call(newState.stateByID, vid)) newState.stateByID[vid] = deepMerge(newState.stateByID[vid], vehicleState)
                else newState.stateByID[vid] = vehicleState

                if(Object.prototype.hasOwnProperty.call(newState.derivativeStateByID, vid)) newState.derivativeStateByID[vid] = deepMerge(newState.derivativeStateByID[vid], vehicleDerivativeState)
                else newState.derivativeStateByID[vid] = vehicleDerivativeState

                if(Object.prototype.hasOwnProperty.call(newState.staticsByID, vid)) newState.staticsByID[vid] = deepMerge(newState.staticsByID[vid], vehicleStatics)
                else newState.staticsByID[vid] = vehicleStatics

                if(Object.prototype.hasOwnProperty.call(newState.geoStateByID, vid)) newState.geoStateByID[vid] = deepMerge(newState.geoStateByID[vid], vehicleGeoState)
                else newState.geoStateByID[vid] = vehicleGeoState

                newState.fuelProfileByID[vid] = vehicleFuelProfile
                newState.vehiclePKGByID[vid] = vehiclePackageProfile

                if(!newState.allIDs.includes(vid)) newState.allIDs.push(vid)

                if(vehicleDerivativeState.transitStatus && !newState.byTransitStatus[vehicleDerivativeState.transitStatus].includes(vid)) {
                    newState.byTransitStatus[vehicleDerivativeState.transitStatus].push(vid)
                } else if (!vehicleDerivativeState.transitStatus || !Object.prototype.hasOwnProperty.call(newState.byTransitStatus, vehicleDerivativeState.transitStatus)) {
                    if(!newState.byTransitStatus[VEHICLE_TRANSIT_STATUS_OBJECT.DISCONNECTED].includes(vid)) {
                        newState.byTransitStatus[VEHICLE_TRANSIT_STATUS_OBJECT.DISCONNECTED].push(vid)
                    }
                }

            }

            newState.byTransitStatus[VEHICLE_TRANSIT_STATUS_OBJECT.ALL] = newState.allIDs || [];

            return newState
        }
        case ActionTypes.GET_VEHICLES: {

            const vehicleStatics = action.vehicleStatics
            const vehicleStates = action.vehicleStates
            const vehicleDerivativeStates = action.vehicleDerivativeStates && action.vehicleDerivativeStates.filter(v => v)
            const vehicleGeoStates = action.vehicleGeoStates && action.vehicleGeoStates.filter(v => v)
            const vehicleFuelProfiles = action.vehicleFuelProfiles
            const vehiclePackageProfiles = action.vehiclePackageProfiles
            const vehicleRuleTemplates = action.vehicleRuleTemplates
            const vehicleMDVRStates = action.vehicleMDVRStates

            vehicleStatics && vehicleStatics.length && vehicleStatics.map(vs => {

                const vid = vs && vs.vid

                if(vid) {
                    if(Object.prototype.hasOwnProperty.call(newState.staticsByID, vid)) newState.staticsByID[vid] = deepMerge(newState.staticsByID[vid], vs)
                    else newState.staticsByID[vid] = vs

                    if(!newState.allIDs.includes(vid)) newState.allIDs.push(vid)
                }

                return null
            })
            
            vehicleRuleTemplates && vehicleRuleTemplates.length && vehicleRuleTemplates.map(vrt => {

                const vid = vrt && vrt.vid
                const ruletid = vrt && vrt.ruletid

                if(vid) {
                    const currRuletid = newState.staticsByID[vid]?.ruletids || []

                    newState.staticsByID[vid] = {
                        ...newState.staticsByID[vid],
                        ruletids: currRuletid.includes(ruletid) ? currRuletid : [ ...currRuletid, ruletid ] 
                    }

                }

                return null
            })

            vehicleStates && vehicleStates.length && vehicleStates.map(vs => {

                const vid = vs && vs.vid

                if(vid) {
                    if(Object.prototype.hasOwnProperty.call(newState.stateByID, vid)) newState.stateByID[vid] = deepMerge(newState.stateByID[vid], vs)
                    else newState.stateByID[vid] = vs
    
                    if(!newState.allIDs.includes(vid)) newState.allIDs.push(vid)
                }

                return null
            })

            vehicleDerivativeStates && vehicleDerivativeStates.length && vehicleDerivativeStates.map(vs => {

                const vid = vs && vs.vid

                if(vid) {
                    if(Object.prototype.hasOwnProperty.call(newState.derivativeStateByID, vid)) newState.derivativeStateByID[vid] = deepMerge(newState.derivativeStateByID[vid], vs)
                    else newState.derivativeStateByID[vid] = vs
    
                    if(!newState.allIDs.includes(vid)) newState.allIDs.push(vid)

                    if(vs.transitStatus && !newState?.byTransitStatus[vs.transitStatus]?.includes(vid)) {
                        newState.byTransitStatus[vs.transitStatus]?.push(vid)
                    }

                }

                return null
            })

            vehicleGeoStates && vehicleGeoStates.length && vehicleGeoStates.map(vs => {

                const vid = vs && vs.vid

                if(vid) {
                    if(Object.prototype.hasOwnProperty.call(newState.geoStateByID, vid)) newState.geoStateByID[vid] = deepMerge(newState.geoStateByID[vid], vs)
                    else newState.geoStateByID[vid] = vs
    
                    if(!newState.allIDs.includes(vid)) newState.allIDs.push(vid)
                }

                return null
            })

            vehicleFuelProfiles && vehicleFuelProfiles.length && vehicleFuelProfiles.map(vfp => {
                const vid = vfp && vfp.vid

                // handling tankNum value from prev
                let tankNum
                Object.keys(vfp).forEach(fp => {
                    const [ num, attr ] = fp.split('_')
                    
                    if(attr) tankNum = Number(num) + 1
                })

                newState.fuelProfileByID[vid] = { ...vfp, tankNum }
            })

            vehiclePackageProfiles && vehiclePackageProfiles.length && vehiclePackageProfiles.map(vpp => {
                const vid = vpp && vpp.vid
                newState.vehiclePKGByID[vid] = vpp
            })

            vehicleMDVRStates && vehicleMDVRStates.length && vehicleMDVRStates.map(mdvr => {
                const vid = mdvr && mdvr.vid
                newState.MDVRStatesByID[vid] = mdvr

                const vehicleDerivativeState = newState.derivativeStateByID[vid] || {}
                const vehicleState = newState.stateByID[vid] || {}

                const location = { 
                    lat: Number(mdvr.location?.lat), 
                    lon: Number(mdvr.location?.lon)
                }
                
                if(location && (!vehicleDerivativeState?.location || !vehicleState?.location)) {
                    newState.derivativeStateByID[vid] = { 
                        vid, 
                        ...mdvr,
                        mdvrid: !Object.keys(vehicleDerivativeState).length && mdvr.mdvrid,
                        ...vehicleDerivativeState
                    }
                    newState.stateByID[vid] = { 
                        vid, 
                        ...mdvr,
                        mdvrid: !Object.keys(vehicleDerivativeState).length && mdvr.mdvrid,
                        ...vehicleState 
                    }

                }
            })

            // // If vehicle don't have data
            // if(vehicleDerivativeStates && vehicleDerivativeStates.length !== vehicleStatics.length) {

            //     const arr = Object.values(newState.byTransitStatus).reduce((arr, cur) => [...arr, ...cur], [])

            //     const UnknownArr = newState.allIDs.filter(vid => !arr.includes(vid))

            //     UnknownArr.length && UnknownArr.map(vid => !newState.byTransitStatus[VEHICLE_TRANSIT_STATUS_OBJECT.DISCONNECTED].includes(vid) && newState.byTransitStatus[VEHICLE_TRANSIT_STATUS_OBJECT.DISCONNECTED].push(vid))

            // }

            newState.byTransitStatus[VEHICLE_TRANSIT_STATUS_OBJECT.ALL] = newState.allIDs || [];

            return newState
        }
        case ActionTypes.GET_VEHICLE_STATE_THRU_PLATE: {
            const vehicleState = action.vehicleState
            const vid = vehicleState.vid

            newState.stateByID[vid] = vehicleState

            return newState
        }
        case ActionTypes.GET_VEHICLE_STATIC_THRU_PLATE: {
            const vehicleStatic = action.vehicleStatics
            const vid = vehicleStatic.vid

            newState.staticsByID[vid] = vehicleStatic

            return newState
        }
        case ActionTypes.SET_SELECTED_VEHICLE: {

            const vid = action.vid

            newState.selectedID = vid

            return newState
        }
        case ActionTypes.UPDATE_VEHICLE_STATE_INFO: {

            const {
                vid,
                vehicle
            } = action

            newState.stateByID[vid] = {
                ...newState.stateByID[vid],
                ...vehicle
            }

            // if(!newState.allIDs.includes(vid)) newState.allIDs.push(vid)

            return newState
        }
        /**
         * WS Action
         */
        case ActionTypes.UPDATE_VEHICLE_INFO_THRU_WS: {

            const {
                vid,
                vehicle
            } = action

            const {
                vehicleDerivativeState = {},
                vehicleState = {},
                vehicleStatic = {},
                MDVRState
            } = vehicle

            const mdvrState = newState.derivativeStateByID[vid]?.mdvrid && MDVRState
                && 
                {
                    ...MDVRState,
                    location: {
                        lat: Number(MDVRState.location?.lat), 
                        lon: Number(MDVRState.location?.lon)
                    },
                }
                ||
                {}

            newState.staticsByID[vid] = {
                ...newState.staticsByID[vid],
                ...vehicleStatic
            }
            newState.stateByID[vid] = {
                ...newState.stateByID[vid],
                ...mdvrState,
                ...vehicleState
            }
            newState.derivativeStateByID[vid] = {
                ...newState.derivativeStateByID[vid],
                ...mdvrState,
                ...vehicleDerivativeState
            }

            if(!newState.allIDs.includes(vid)) newState.allIDs.push(vid)

            if(vehicleDerivativeState.transitStatus && !newState.byTransitStatus[vehicleDerivativeState.transitStatus].includes(vid)) {
                newState.byTransitStatus[vehicleDerivativeState.transitStatus].push(vid)
            } else if (!vehicleDerivativeState.transitStatus || !Object.prototype.hasOwnProperty.call(newState.byTransitStatus, vehicleDerivativeState.transitStatus)) {
                if(!newState.byTransitStatus[VEHICLE_TRANSIT_STATUS_OBJECT.DISCONNECTED].includes(vid)) {
                    newState.byTransitStatus[VEHICLE_TRANSIT_STATUS_OBJECT.DISCONNECTED].push(vid)
                }
            }

            return newState
        }
        case ActionTypes.UPDATE_VEHICLE_GEO_STATE_THRU_WS: {

            const {
                vid,
                vehicle
            } = action

            const {
                VGState = {}
            } = vehicle

            newState.geoStateByID[vid] = {
                ...newState.geoStateByID[vid],
                ...VGState
            }

            // if(!newState.allIDs.includes(vid)) newState.allIDs.push(vid)

            return newState
        }
        case ActionTypes.UPDATE_VEHICLE_ADDRESS: {

            const { vid, address } = action.data || {}


            if(address) {
                newState.stateByID[vid] = {
                    ...newState?.stateByID[vid],
                    address
                }
            } 

            return newState
        }
        case ActionTypes.UPDATE_VEHICLE_ADDRESSES: {

            const data = action.data

            data && data.length && data.map(d => {
                const { vid, address } = d || {}
                
                if(address) {
                    newState.stateByID[vid] = {
                        ...newState?.stateByID[vid],
                        address
                    }
                } 
                
            })

            return newState
        }
        case ActionTypes.CREATE_VEHICLES: {
            const vehicles = action.vehicles 

            vehicles && vehicles.length && vehicles.map(vehicle => {

                const vehic = vehicle?.vehicle
                const vid = vehic?.vid

                newState.staticsByID[vid] = vehic

                if(!newState.allIDs.includes(vid)) {
                    newState.allIDs.push(vid)
                }
            })
            return newState
        }
        case ActionTypes.CREATE_VEHICLE: 
        case ActionTypes.UPDATE_VEHICLE: {
            const vehicle = action.vehicle

            newState.staticsByID[vehicle.vid] = vehicle
            newState.vehiclePKGByID[vehicle.vid] = { vpkgids: vehicle.vpkgids }
            newState.fuelProfileByID[vehicle.vid] = vehicle.fuelProfile && vehicle.fuelProfile

            return newState
        }
        default: {
            return newState;
        }
    }
}